import 'twin.macro';

import React from 'react';

import CardImage from '@/assets/images/prepaid_img.webp';

import CardBanner from '../card-banner';

const benefits = [
  'Оформление онлайн за 5 минут без посредников',
  'Моментальный выпуск цифровой карты',
  'Номиналы в 50, 100, 200, 300 и 400 долларов'
];
function LandingPrepaidBanner() {
  return (
    <>
      <CardBanner
        title={'Предоплаченные карты'}
        benefits={benefits}
        buttonText={'Купить карту'}
        navigateUrl={'/prepaid-card/apply'}
        cardImage={CardImage}
        type='prepaid'
      />
    </>
  );
}

export default LandingPrepaidBanner;
